import { useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Tooltip } from 'primereact/tooltip';

export const PanelAyuda = ({ content }) => {
    const [visible, setVisible] = useState(false);

    if (!content) return null;

    return (
        <>
            <Tooltip target=".icono-ayuda-animado" position="top" />
            <i className="pi pi-question-circle ml-2 cursor-pointer icono-ayuda-animado" style={{ fontSize: '1.15rem' }} data-pr-tooltip="Clic para ver la ayuda" onClick={() => setVisible(true)} />

            <Sidebar visible={visible} position="right" onHide={() => setVisible(false)} style={{ width: '40vw', maxWidth: '100vw' }}>
                <div className="px-3 pb-4">
                    {content}
                </div>
            </Sidebar>
        </>
    );
};